import axios from "axios";

export { createLocation, updateLocation, deleteLocation, getLocations };
/**
 * @param {string} buyerAccountId 
 * @param {Location} location Consists of name, address: { addressLine1, addressLine2, county, postCode, country }, company, notes, contact: { name, phone, email },
 * @returns {Location|Boolean} Returns created location, false if fail
 */
async function createLocation(buyerAccountId, location) {
  try {
    const res = await axios.post(`/api/location/${buyerAccountId}`, { params: { location } });
    return res;
  } catch (ex) {
    return false;
  }
}

/**
 * @param {String} locationId 
 * @param {Location} location Consists of name, address: { addressLine1, addressLine2, county, postCode, country }, company, notes, contact: { name, phone, email },
 * @returns {Location|Boolean} Returns updated location, false if fail
 */
async function updateLocation(locationId, location) {
  try {
    const res = await axios.put(`/api/location/${locationId}`, { params: { location } });
    return res;
  } catch (ex) {
    return false;
  }
}

/**
 * @param {String} locationId 
*/
 async function deleteLocation(locationId) {
  try {
  const res = await axios.delete(`/api/location/${locationId}`);
  return res;
  } catch (ex) {
    return false;
  }
}

/**
 * @param {String} buyerAccountId 
 * @returns 
 */
function getLocations(buyerAccountId) {
  try {
    return axios.get(`/api/locations/${buyerAccountId}`);
  } catch (ex) {
    return false;
  }
}

/**
 * @typedef {Object} Location
 * @property {String} name
 * @property {Address} address
 * @property {String} company
 * @property {String} notes
 * @property {Contact} contact
 */
/**
 * @typedef {Object} Address
 * @property {String} addressLine1
 * @property {String} addressLine2
 * @property {String} county
 * @property {String} postCode
 * @property {String} country
 */
/**
 * @typedef {Object} Contact
 * @property {String} name
 * @property {String} phone
 * @property {String} email
 */